import React from 'react';
import { Tag } from 'antd';

interface Props {
	/** Shown in the fallback so the operator still sees the recorded value. */
	fallbackValue?: string | number | null;
	children: React.ReactNode;
}

interface State {
	hasError: boolean;
}

/**
 * Per-balloon-row boundary for the hand-quality entry UI. A render error in
 * one balloon's slider (e.g. a value outside the slider's range) must degrade
 * to a small inline fallback instead of unmounting the entire section.
 */
class BalloonRowErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ flex: 1, padding: '0 12px' }}>
					<Tag color="error">
						Could not display slider
						{this.props.fallbackValue != null && this.props.fallbackValue !== ''
							? ` (value: ${this.props.fallbackValue})`
							: ''}
						{' — use Edit to enter the measurement'}
					</Tag>
				</div>
			);
		}
		return this.props.children;
	}
}

export default BalloonRowErrorBoundary;
